import { motion } from 'framer-motion'
import { Sparkles, Lightbulb, TrendingUp, Target, CheckCircle, Zap } from 'lucide-react'
import FeatureLayout from '../../components/FeatureLayout'
import { useLanguage } from '../../contexts/LanguageContext'

export default function AITipsPage() {
  const { t } = useLanguage()

  const exampleTips = [
    {
      icon: Zap,
      title: t('aiTips.modal.example1.title'),
      description: t('aiTips.modal.example1.description'),
    },
    {
      icon: TrendingUp,
      title: t('aiTips.modal.example2.title'),
      description: t('aiTips.modal.example2.description'),
    },
    {
      icon: Target,
      title: t('aiTips.modal.example3.title'),
      description: t('aiTips.modal.example3.description'),
    },
    {
      icon: Lightbulb,
      title: t('aiTips.modal.example4.title'),
      description: t('aiTips.modal.example4.description'),
    },
  ]

  return (
    <FeatureLayout
      title={t('aiTips.modal.title')}
      subtitle={t('aiTips.modal.subtitle')}
      gradientFrom="from-cyan-500"
      gradientTo="to-blue-500"
      icon={<Sparkles className="h-10 w-10 text-white" />}
      featureName="AI Tips"
    >
      {/* What Is Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-cyan-500/10 to-blue-500/10 rounded-3xl p-8 lg:p-12 border border-cyan-500/20">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-cyan-500/20 rounded-2xl">
              <Sparkles className="h-8 w-8 text-cyan-400" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">{t('aiTips.modal.whatIs')}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{t('aiTips.modal.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Example Tips */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('aiTips.modal.exampleTips')}</h2>

        <div className="grid md:grid-cols-2 gap-6">
          {exampleTips.map((tip, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-2xl p-6 border border-cyan-500/20"
            >
              <div className="flex items-start gap-4 mb-3">
                <div className="p-2 bg-cyan-500/20 rounded-lg">
                  <tip.icon className="h-6 w-6 text-cyan-400" />
                </div>
                <h3 className="text-lg font-bold text-white">{tip.title}</h3>
              </div>
              <p className="text-gray-300 italic text-sm pl-12">{tip.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="bg-gradient-to-r from-cyan-600/20 to-blue-600/20 rounded-3xl p-8 lg:p-12 border border-cyan-500/30 text-center">
          <CheckCircle className="h-16 w-16 text-cyan-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">{t('aiTips.modal.cta')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('aiTips.modal.ctaDescription')}
          </p>
          <a
            href="/#waitlist"
            className="inline-block px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white font-semibold rounded-xl transition-all transform hover:scale-105"
          >
            Join Waitlist Now
          </a>
        </div>
      </section>
    </FeatureLayout>
  )
}
